module.exports = __webpack_public_path__ + "static/media/gift02_en.ba2ca52d.png";